"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callout = void 0;
/* eslint-disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".callout_ad5629e1 .ms-Suggestions-itemButton{padding:0;border:none}.callout_ad5629e1 .ms-Suggestions{min-width:300px}" }]);
exports.callout = "callout_ad5629e1";
//# sourceMappingURL=BaseFloatingPicker.scss.js.map